import { useEffect, useState } from 'react';
import { clienteService, pagoService, prestamoService } from '../../services/api';
import '../../styles/Pagos.css';

const EliminarPago = () => {
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState('');
  const [pagos, setPagos] = useState([]);
  const [pagoSeleccionado, setPagoSeleccionado] = useState(null);
  const [busquedaId, setBusquedaId] = useState('');
  const [confirmacion, setConfirmacion] = useState(false);
  const [busquedaCliente, setBusquedaCliente] = useState('');
  const [mostrarDropdown, setMostrarDropdown] = useState(false);
  const [clienteObj, setClienteObj] = useState(null);
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });

  useEffect(() => {
    cargarClientes();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.form-group')) {
        setMostrarDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const cargarClientes = async () => {
    try {
      const response = await clienteService.getAll({ per_page: 1000 });
      setClientes(response.data.clientes || []);
    } catch (error) {
      console.error('Error al cargar clientes:', error);
    }
  };

  const clientesFiltrados = clientes.filter(cliente => {
    const termino = busquedaCliente.toLowerCase().trim();
    if (!termino) return true;

    return (
      (cliente.nombres && cliente.nombres.toLowerCase().includes(termino)) ||
      (cliente.apellidos && cliente.apellidos.toLowerCase().includes(termino)) ||
      (cliente.cedula && cliente.cedula.includes(termino)) ||
      (cliente.apodo && cliente.apodo.toLowerCase().includes(termino)) ||
      cliente.id.toString().includes(termino) ||
      (cliente.nombres && cliente.apellidos &&
       `${cliente.nombres} ${cliente.apellidos}`.toLowerCase().includes(termino))
    );
  }).slice(0, 10);

  const seleccionarCliente = async (cliente) => {
    setClienteObj(cliente);
    setBusquedaCliente(`${cliente.nombres} ${cliente.apellidos} - ${cliente.cedula}`);
    setMostrarDropdown(false);
    setClienteSeleccionado(cliente.id);
    setPagos([]);
    setPagoSeleccionado(null);

    try {
      const response = await prestamoService.getAll({ cliente_id: cliente.id });
      const prestamos = response.data.prestamos || [];

      // Cargar pagos de todos los préstamos del cliente
      const todosPagos = [];
      for (const prestamo of prestamos) {
        const pagosResponse = await pagoService.getByPrestamo(prestamo.id);
        const pagosConInfo = (pagosResponse.data.pagos || []).map(pago => ({
          ...pago,
          prestamo: prestamo,
          cliente: pagosResponse.data.cliente
        }));
        todosPagos.push(...pagosConInfo);
      }

      todosPagos.sort((a, b) => new Date(b.fecha_pago) - new Date(a.fecha_pago));
      setPagos(todosPagos);
    } catch (error) {
      console.error('Error al cargar pagos:', error);
    }
  };

  const limpiarCliente = () => {
    setClienteObj(null);
    setClienteSeleccionado('');
    setBusquedaCliente('');
    setPagos([]);
    setPagoSeleccionado(null);
  };

  const handleBuscarPorId = async () => {
    if (!busquedaId) return;

    try {
      const response = await pagoService.getById(busquedaId);
      setPagoSeleccionado(response.data);
      setConfirmacion(false);
    } catch (error) {
      setMensaje({ tipo: 'error', texto: 'Pago no encontrado' });
    }
  };

  const handleSeleccionarPago = (pago) => {
    setPagoSeleccionado(pago);
    setConfirmacion(false);
  };

  const handleEliminar = async () => {
    if (!confirmacion) {
      setMensaje({ tipo: 'error', texto: 'Debe confirmar la eliminación' });
      return;
    }

    if (!pagoSeleccionado) {
      setMensaje({ tipo: 'error', texto: 'No hay un pago seleccionado' });
      return;
    }

    try {
      await pagoService.delete(pagoSeleccionado.id);
      setMensaje({ tipo: 'success', texto: 'Pago eliminado exitosamente' });

      // Limpiar
      setPagoSeleccionado(null);
      setConfirmacion(false);
      setBusquedaId('');

      // Recargar pagos si hay un cliente seleccionado
      if (clienteSeleccionado) {
        const cliente = clientes.find(c => c.id === clienteSeleccionado);
        if (cliente) {
          seleccionarCliente(cliente);
        }
      }
    } catch (error) {
      setMensaje({ tipo: 'error', texto: error.response?.data?.error || 'Error al eliminar el pago' });
    }
  };

  return (
    <div className="eliminar-pago-container">
      <h2>Eliminar Pago</h2>

      {mensaje.texto && (
        <div className={`mensaje ${mensaje.tipo}`}>
          {mensaje.texto}
        </div>
      )}

      <div className="busqueda-section">
        <div className="form-group">
          <label>Buscar por Cliente:</label>
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              className="form-control"
              placeholder="Buscar por nombre, cédula, apodo o ID..."
              value={busquedaCliente}
              onChange={(e) => {
                setBusquedaCliente(e.target.value);
                setMostrarDropdown(true);
              }}
              onFocus={() => setMostrarDropdown(true)}
            />
            {clienteObj && (
              <button
                type="button"
                onClick={limpiarCliente}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#6c757d'
                }}
              >
                ×
              </button>
            )}

            {mostrarDropdown && busquedaCliente && clientesFiltrados.length > 0 && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: 'white',
                border: '1px solid #ddd',
                borderRadius: '4px',
                maxHeight: '400px',
                overflowY: 'auto',
                zIndex: 1000,
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {clientesFiltrados.map((cliente) => (
                  <div
                    key={cliente.id}
                    onClick={() => seleccionarCliente(cliente)}
                    style={{
                      padding: '10px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    {cliente.foto_url ? (
                      <img
                        src={cliente.foto_url}
                        alt={cliente.nombres}
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          objectFit: 'cover'
                        }}
                      />
                    ) : (
                      <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#007bff',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold'
                      }}>
                        {cliente.nombres?.charAt(0)}{cliente.apellidos?.charAt(0)}
                      </div>
                    )}
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 'bold' }}>
                        {cliente.nombres} {cliente.apellidos}
                        {cliente.apodo && (
                          <span style={{
                            marginLeft: '8px',
                            color: '#007bff',
                            fontStyle: 'italic',
                            fontWeight: 'normal'
                          }}>
                            ({cliente.apodo})
                          </span>
                        )}
                      </div>
                      <div style={{ fontSize: '0.9em', color: '#666' }}>
                        Cédula: {cliente.cedula} • ID: {cliente.id}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="separador">O</div>

        <div className="busqueda-id">
          <label>Buscar por ID de Pago:</label>
          <div className="input-group">
            <input
              type="text"
              value={busquedaId}
              onChange={(e) => setBusquedaId(e.target.value)}
              placeholder="ID del pago"
            />
            <button type="button" onClick={handleBuscarPorId}>Buscar</button>
          </div>
        </div>
      </div>

      {pagos.length > 0 && (
        <div className="pagos-list">
          <h3>Pagos del Cliente</h3>
          <table className="tabla-pagos">
            <thead>
              <tr>
                <th>ID</th>
                <th>Fecha</th>
                <th>Préstamo</th>
                <th>Capital</th>
                <th>Interés</th>
                <th>Mora</th>
                <th>Total</th>
                <th>Tipo</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {pagos.map(pago => (
                <tr
                  key={pago.id}
                  className={pagoSeleccionado?.id === pago.id ? 'selected' : ''}
                >
                  <td>{pago.id}</td>
                  <td>{new Date(pago.fecha_pago).toLocaleDateString()}</td>
                  <td>#{pago.prestamo_id}</td>
                  <td>${pago.monto_capital.toFixed(2)}</td>
                  <td>${pago.monto_interes.toFixed(2)}</td>
                  <td>${pago.monto_mora.toFixed(2)}</td>
                  <td>${pago.monto_total.toFixed(2)}</td>
                  <td>{pago.tipo_pago}</td>
                  <td>
                    <button
                      className="btn-small"
                      onClick={() => handleSeleccionarPago(pago)}
                    >
                      Seleccionar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {pagoSeleccionado && (
        <div className="pago-detalle">
          <h3>Detalle del Pago a Eliminar</h3>

          <div className="detalle-grid">
            <div className="detalle-item">
              <strong>ID del Pago:</strong>
              <span>{pagoSeleccionado.id}</span>
            </div>
            <div className="detalle-item">
              <strong>Préstamo ID:</strong>
              <span>{pagoSeleccionado.prestamo_id}</span>
            </div>
            <div className="detalle-item">
              <strong>Fecha:</strong>
              <span>{new Date(pagoSeleccionado.fecha_pago).toLocaleDateString()}</span>
            </div>
            <div className="detalle-item">
              <strong>Capital:</strong>
              <span>${pagoSeleccionado.monto_capital.toFixed(2)}</span>
            </div>
            <div className="detalle-item">
              <strong>Interés:</strong>
              <span>${pagoSeleccionado.monto_interes.toFixed(2)}</span>
            </div>
            <div className="detalle-item">
              <strong>Mora:</strong>
              <span>${pagoSeleccionado.monto_mora.toFixed(2)}</span>
            </div>
            <div className="detalle-item total">
              <strong>Total:</strong>
              <span>${pagoSeleccionado.monto_total.toFixed(2)}</span>
            </div>
            <div className="detalle-item">
              <strong>Tipo:</strong>
              <span>{pagoSeleccionado.tipo_pago}</span>
            </div>
          </div>

          {pagoSeleccionado.detalle && (
            <div className="detalle-notas">
              <strong>Detalle:</strong>
              <p>{pagoSeleccionado.detalle}</p>
            </div>
          )}

          <div className="advertencia">
            <p>⚠️ <strong>ADVERTENCIA:</strong> Esta acción no se puede deshacer.
            Al eliminar este pago, se actualizará el estado del préstamo.</p>
          </div>

          <div className="confirmacion-check">
            <label>
              <input
                type="checkbox"
                checked={confirmacion}
                onChange={(e) => setConfirmacion(e.target.checked)}
              />
              Confirmo que deseo eliminar este pago
            </label>
          </div>

          <div className="form-actions">
            <button
              className="btn-danger"
              onClick={handleEliminar}
              disabled={!confirmacion}
            >
              Eliminar Pago
            </button>
            <button
              className="btn-secondary"
              onClick={() => {
                setPagoSeleccionado(null);
                setConfirmacion(false);
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EliminarPago;
